import { FC } from "react";
import Link from "common/components/base/link";
import { IconCollection } from "common/config/media.config";
import Icon from "common/components/base/icon";
import { ErrorOutline, Refresh } from "@mui/icons-material";
import "./Fallback.scss";

const Fallback: FC = () => {
  return (
    <div className="motif-row fallback__container">
      <div className="fallback__main-icon">
        <ErrorOutline />
      </div>
      <div className="fallback__content">
        <span className="fallback__heading">Sorry, something went wrong.</span>
        <div className="fallback__reload-wrap">
          <Refresh />
          <Link href={"/"} className="fallback__link" variant="alt">
            Reload
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Fallback;
